import { Meta } from '@angular/platform-browser';
import { METATAGSARRAY } from '@qaroni-merchant-core/types/metadata/meta-tags.array';

const metaTagsPromise = (meta: Meta): Promise<void> => {
  return new Promise(resolve => {
    METATAGSARRAY.forEach(tag => {
      if (tag.property) {
        meta.updateTag({ property: tag.property, content: tag.content });
      } else if (tag.itemprop) {
        meta.updateTag({ itemprop: tag.itemprop, content: tag.content });
      } else {
        meta.updateTag({ name: tag.name, content: tag.content });
      }
    });

    resolve();
  });
};

export function initializeMetaTags(meta: Meta): () => Promise<void> {
  return () => metaTagsPromise(meta);
}
